module.exports = __webpack_public_path__ + "img/anquanzhongxin.b75b8976.png";